import {createAsyncThunk} from "@reduxjs/toolkit";
import {API_TIMEOUTS_MILLISECONDS} from "commonUtils/enumerations";
import {
  AUTHENTICATE_ENDPOINT,
  LOGIN_VERIFY_MFA_OTP,
} from "commonUtils/globalAPISettings";
import {isValidObject} from "commonUtils/utils";
import type {LoginDataProps, MfaOtpDataProps} from "features/Login/loginStyle";
import {postRequest, setHeader} from "repository/genericRepository";

const APIHeaders = {
  Authorization: `Bearer ${process.env.REACT_APP_API_AUTH_TOKEN}`,
};

export const userLogin = createAsyncThunk(
  "auth/login",
  async (loginData: LoginDataProps, {rejectWithValue}) => {
    try {
      const {userIdentity, password, isEncrypted, loginTypeId} = loginData;
      const details = await postRequest({
        url: AUTHENTICATE_ENDPOINT,
        headers: setHeader(APIHeaders),
        params: {userIdentity, password, isEncrypted, loginTypeId},
        timeout: API_TIMEOUTS_MILLISECONDS.AUTHENTICATE_ENDPOINT,
        data: {},
      });
      if (isValidObject(details)) {
        return details;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const verifyMfaOtp = createAsyncThunk(
  "auth/verifymfaotp",
  async (verifyMfaOtpData: MfaOtpDataProps, {rejectWithValue}) => {
    try {
      const {userIdentity, otp} = verifyMfaOtpData;
      const details = await postRequest({
        url: LOGIN_VERIFY_MFA_OTP,
        headers: setHeader(APIHeaders),
        params: {userIdentity, otp},
        timeout: API_TIMEOUTS_MILLISECONDS.LOGIN_VERIFY_MFA_OTP,
        data: {},
      });
      if (isValidObject(details)) {
        return details;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
